
import React from 'react';
import AddMenu from './AddMenu';
import DashboardLayout from '../../../components/Shop/RestaurantLayout/Layout/DashboardLayout';
import messages from '../../../locale/messages';

function action({ store, intl, params }) {
  const title = intl.formatMessage(messages.addMenu);

  let isRestaurantAuthenticated = store.getState().runtime.isRestaurantAuthenticated;

  if (!isRestaurantAuthenticated) {
    return { redirect: '/restaurant' };
  };

  return {
    title,
    component: (
      <DashboardLayout>
        <AddMenu title={title} />
      </DashboardLayout>
    ),
  };
}

export default action;
